const { copyToClipboard } = window.BAO.Utils

class WishlistShare extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleFormSuccess = this.handleFormSuccess.bind(this)

    this.handleCopyLink = this.handleCopyLink.bind(this)
    this.handleFacebook = this.handleFacebook.bind(this)
    this.handleWhatsapp = this.handleWhatsapp.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)

    this.els.copy.elements.forEach((copy) => {
      this.listeners.add(copy, 'click', this.handleCopyLink)
    })

    this.els.facebook.elements.forEach((facebook) => {
      this.listeners.add(facebook, 'click', this.handleFacebook)
    })

    this.els.whatsapp.elements.forEach((whatsapp) => {
      this.listeners.add(whatsapp, 'click', this.handleWhatsapp)
    })
  }

  handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-share-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    this.els.success.element.setAttribute('aria-hidden', 'true')
    this.els.main.element.setAttribute('aria-hidden', 'false')

    this.els.submit.element.setAttribute(
      'data-wishlist-id',
      trigger.dataset.wishlistId,
    )

    this.els.recipientemail.element.value = ''
    this.els.sendername.element.value = ''
    this.els.message.element.value = ''
  }

  handleSubmit (e) {
    if (this.els.form.element.reportValidity()) {
      e.preventDefault()

      const params = {
        toEmailId: this.els.recipientemail.element.value,
        fromName: this.els.sendername.element.value,
        note: this.els.message.element.value,
        lid: this.els.submit.element.dataset.wishlistId,
        cprops: {},
      }

      window._swat.sendListViaEmail(
        params,
        this.handleFormSuccess,
        this.wishlistError,
      )
    }
  }

  handleCopyLink () {
    const lid = this.els.submit.element.dataset.wishlistId

    const onSuccess = (link) => {
      copyToClipboard(link)

      this.els['copy-text'].elements.forEach((copyText) => {
        copyText.innerHTML = this.els.copy.element.dataset.copied
      })
    }

    const onError = (error) => {
      this.log('Error while generating the link', error)
    }

    // Mark the list public before generating the link
    window._swat.markListPublic(lid)

    window._swat.generateSharedListURL(lid, onSuccess, onError)
  }

  handleFacebook () {
    const lid = this.els.submit.element.dataset.wishlistId

    const fromName = ''
    const platformShareUrlTemplate =
      'https://www.facebook.com/sharer.php?u={{shareurl}}&t={{note}}'
    const platform = 'facebook'
    const note = ''

    const onError = function (error) {
      this.log('There was an Error opening the share platform', error)
    }

    window._swat.shareListSocial(
      lid,
      fromName,
      platformShareUrlTemplate,
      platform,
      note,
      onError,
    )
  }

  handleWhatsapp () {
    const lid = this.els.submit.element.dataset.wishlistId

    const onSuccess = (link) => {
      const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(link)}`

      window.location.href = url
    }

    const onError = (error) => {
      this.log('Error while generating the link', error)
    }

    window._swat.generateSharedListURL(lid, onSuccess, onError)
  }

  handleFormSuccess () {
    this.els.success.element.setAttribute('aria-hidden', 'false')
    this.els.main.element.setAttribute('aria-hidden', 'true')
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);
  }
}

if (!customElements.get('wishlist-share')) {
  customElements.define('wishlist-share', WishlistShare)
}
